export default "__VITE_ASSET__lb9YOzs7__"